import { Record } from 'immutable'

export interface ICommissionSplit {
  readonly listingFee: number
  readonly sellingFee: number
}

const CommissionSplitRecord = Record({
  listingFee: 0,
  sellingFee: 0,
})

export class CommissionSplit extends CommissionSplitRecord
  implements ICommissionSplit {
  public static fromJS(initialState?: Partial<ICommissionSplit>) {
    return new CommissionSplit(initialState)
  }

  public readonly listingFee: number
  public readonly sellingFee: number

  constructor(props?: Partial<CommissionSplit>) {
    props ? super(props) : super()
  }
}
